// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"526":"ad44b2be8754a5f5","806":"902c4cc2eb0b8b7b","904":"14bc0795db35ccdc"}[chunkId] + ".js";
};